import { User } from 'lucide-react';
import { cn } from '@/lib/utils';

interface UserAvatarProps {
    src?: string | null;
    alt?: string;
    size?: 'xs' | 'sm' | 'md' | 'lg';
    className?: string;
}

const sizeClasses = {
    xs: 'w-8 h-8',
    sm: 'w-12 h-12',
    md: 'w-16 h-16',
    lg: 'w-24 h-24',
} as const;

const iconSizes = {
    xs: 14,
    sm: 20,
    md: 28,
    lg: 40,
} as const;

export function UserAvatar({ src, alt, size = 'md', className }: UserAvatarProps) {
    return (
        <div className={cn(
            sizeClasses[size],
            'rounded-full bg-slate-100 overflow-hidden flex items-center justify-center flex-shrink-0',
            className,
        )}>
            {src ? (
                <img src={src} alt={alt ?? ''} className="w-full h-full object-cover" />
            ) : (
                <User size={iconSizes[size]} className="text-slate-300" />
            )}
        </div>
    );
}
